import React,{useContext, useState, useEffect, useRef} from 'react'
import {Col, Form} from 'react-bootstrap'
import styles from '../../UI/css/General.module.css'
import styles2 from '../css/COLUMN.module.css'
import {AppContext} from '../../Resources/CanvasContextFile'
import ElemDeleteControl from "./ElemDeleteControlWrapper"
import { handleDisplayProperty } from '../../components/IFormDesignerLayout/IFormDesignerLogic'
import { useSelector } from "../../Redux";
import { GetStateFromData, useElementWidth } from '../../components/CustomHooks/CustomHooks'

const EMAIL = (props) => {
    const data = props.data;
    const AppContextVar = useContext(AppContext);
    var deleteControl;

    const labelStyle={
        fontSize:"12px"
    }

    if(AppContextVar!==undefined){
      deleteControl = AppContextVar.deleteControl;
    } 

    const [mobileDisplay, setMobileDisplay] = useState(true);
    const [tabDisplay, setTabDisplay] = useState(true);

    const contexts = GetStateFromData(props.containerId);

    const { formState2, device} = contexts.contexts;
	let canvasWidth=useElementWidth(null, props?.previewmode);
    const startMobile = useRef();
    const endMobile= useRef();
    const startTab= useRef();
    const endTab= useRef();

    useEffect(() => {
        if (formState2 && formState2.style) {
            startMobile.current = parseInt(formState2.style?.["Breakpoint"]?.["Mobile"]?.["StartValue"]);
            endMobile.current = parseInt(formState2.style?.["Breakpoint"]?.["Mobile"]?.["EndValue"]);
            startTab.current = parseInt(formState2.style?.["Breakpoint"]?.["Tab"]?.["StartValue"]);
            endTab.current = parseInt(formState2.style?.["Breakpoint"]?.["Tab"]?.["EndValue"]);
        }
    },[formState2.style?.["Breakpoint"], formState2.style?.["Breakpoint"]?.["Mobile"], formState2.style?.["Breakpoint"]?.["Tab"]]); 

    useEffect(() => {
        if(props?.previewmode)
        handleDisplayProperty(props, device, setMobileDisplay, setTabDisplay, startMobile.current, endMobile.current, startTab.current, endTab.current)
      },[props?.data?.style?.["MobileVisible"], props?.data?.style?.["TabsVisible"], device, endMobile, endTab, startMobile, startTab,canvasWidth]);

    
    if(props.previewmode){
        return (
            <Form.Group 
            // onClick={(e)=>props.handleSelected(e,props.id,"n")}
            // onMouseEnter={(e)=>props.handleSelected(e,props.id,"y")}
            // onMouseLeave={(e)=>props.handleSelected(e,"","y")}
            className={styles2.formStyle}
            style={mobileDisplay === false || tabDisplay === false ? {display:"none"} : {display:"block"}}
             key={data.id} id={data.id} elem_type='email'  frameindex={props.data.frameIndex}  elementindex={props.data.elementIndex} 
             sheetIndex={props.data.sheetIndex} sheetElementIndex={props.data.sheetElementIndex} sheetFrameElementindex={props.data.sheetFrameElementindex}>
                <Form.Label style={labelStyle} id={data.id} elem_type='email'  frameindex={props.data.frameIndex}  elementindex={props.data.elementIndex}>
                    {data.style.label?data.style.label:data.style.id}
                </Form.Label>
                <Form.Control type="email" id={data.id} placeholder={data.placeholder?data.placeholder:'example@domain.com'}  elem_type='email'  frameindex={props.data.frameIndex}  elementindex={props.data.elementIndex}/>
            </Form.Group>
        );
    }
    else {
        return (
            <Form.Group 
            onClick={(e)=>props.handleSelected(e,props.id,"n")}
            // onMouseEnter={(e)=>props.handleSelected(e,props.id,"y")}
            // onMouseLeave={(e)=>props.handleSelected(e,"","y")}
            className={styles2.formStyle}
             key={data.id} id={data.id} tabIndex="1" elem_type='email'  frameindex={props.data.frameIndex}  elementindex={props.data.elementIndex}
             sheetIndex={props.data.sheetIndex} sheetElementIndex={props.data.sheetElementIndex} sheetFrameElementindex={props.data.sheetFrameElementindex}>
                <Form.Label style={labelStyle} id={data.id} elem_type='email'  frameindex={props.data.frameIndex}  elementindex={props.data.elementIndex}>
                    {data.style.label?data.style.label:data.style.id}
                </Form.Label>
                <Form.Control type="email" id={data.id} placeholder={data.placeholder?data.placeholder:'example@domain.com'}  elem_type='email'  frameindex={props.data.frameIndex}  elementindex={props.data.elementIndex}/>
                <ElemDeleteControl containerId={props.containerId} id={props.id} deleteControl={deleteControl} elemType={props.data.elem_type} 
                data={props.data}/> 
                </Form.Group>
        );

    }
}

export default EMAIL